import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Input, Flex, Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { App } from "antd";
import { useNavigate } from "react-router-dom";
import { createOrUpdateWarehouse } from "../warehousesThunks";
import { setSelectedWarehouse, setIsEditWarehouse } from "../warehousesSlice";
import InputField from "../../../../components/Input/Input";
import { getAccessType } from "../../../../lib/functions";

const { Title } = Typography;

const CreateWarehouseForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const { useBreakpoint } = Grid;
  let [access_type, access_type_set] = useState("");

  const { isEditWarehouse, selectedWarehouse } = useSelector(
    (state) => state.warehouses
  );

  useEffect(() => {
    const access = getAccessType("warehouse_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    if (isEditWarehouse && selectedWarehouse) {
      form.setFieldsValue(selectedWarehouse);
    } else {
      form.resetFields();
    }
  }, [isEditWarehouse, selectedWarehouse]);

  const handleCancel = () => {
    dispatch(setSelectedWarehouse(null));
    dispatch(setIsEditWarehouse(false));
    navigate(-1);
  };
  const screens = useBreakpoint();
  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateWarehouse({
          ...values,
          action: isEditWarehouse ? "update" : "create",
          id: selectedWarehouse?.id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditWarehouse
          ? "Warehouse updated successfully"
          : "Warehouse created successfully",
      });

      dispatch(setSelectedWarehouse(null));
      dispatch(setIsEditWarehouse(false));
      navigate("/settings/warehouses/");
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="warehouse-form">
      <Title
        level={2}
        style={{ marginBottom: "32px", fontSize: "clamp(20px, 5vw, 30px)" }}
      >
        {isEditWarehouse ? "Update Warehouse" : "Create New Warehouse"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        //  style={{ maxWidth: "1400px", margin: "0 auto" }}
        className="responsive-form"
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Warehouse Name"
              name="name"
              rules={[
                { required: true, message: "Warehouse name is required" },
              ]}
            >
              <InputField
                placeholder="Enter Warehouse Name"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="Warehouse Title"
              name="title"
              rules={[
                { required: true, message: "Warehouse title is required" },
              ]}
            >
              <InputField
                placeholder="Enter Warehouse Title"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Flex>
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Warehouse Address"
              name="address"
              rules={[
                { required: true, message: "Warehouse address is required" },
              ]}
            >
              <Input.TextArea placeholder="Enter Warehouse Address" rows={3} />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex
          style={{ marginBottom: "32px", width: "100%", maxWidth: "320px" }}
          gap={!screens.md ? 16 : 32}
          wrap="wrap"
        >

          <Button
            onClick={handleCancel}
            size="large"
            shape="default"
            className="traic-button"
          >
            Back
          </Button>

          {access_type == "WRITE" && <>
            <Button
              type="primary"
              htmlType="submit"
              className="traic-button"
              size="large"
            >
              {isEditWarehouse ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateWarehouseForm;
